<template>
  <div class="wrap-diagram">
    <div class="structure-diagram" id="myDiagramDiv"></div>
    <div class="diagram-description" v-if="description !== null" v-html="description"></div>
  </div>
</template>

<script>
export default {
  props: ["data"],
  data() {
    return {
      description: null
    }
  },
  mounted() {
     this.createDiagram(this.data);
  },
  methods: {
    showDescription(id) {

    },
    createDiagram(data) {
      var $ = go.GraphObject.make;
      var myDiagram =
        $(go.Diagram, 'myDiagramDiv',
            {
                "undoManager.isEnabled": true,
                layout: $(go.TreeLayout,
                    { angle: 90, layerSpacing: 35 },)
            });
      myDiagram.nodeTemplate =
        $(go.Node, "Horizontal",
          { background: "#008496", margin: 5},
          $(go.Picture,
            new go.Binding("source")),
          $(go.TextBlock, "Default Text",
            { margin: 5, width: 78, textAlign: "center" , stroke: "white", font: "bold 14px KazNet" },
            new go.Binding("text", "name")),
            {
              click: (e, obj) => {
                this.description = obj.part.data.description;
              }
            }
        );
      myDiagram.linkTemplate =
        $(go.Link,
          { routing: go.Link.Orthogonal, corner: 5 },
          $(go.Shape, { strokeWidth: 3, stroke: "#555" }));

      var model = $(go.TreeModel);
      model.nodeDataArray = data;
      myDiagram.model = model;
    }
  }
}
</script>

<style>
.structure-diagram {
  border: none;
  width: 100%;
  height: 500px;
  overflow: hidden;
}
.structure-diagram canvas:focus {
  outline: none;
}
.structure-diagram canvas::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.structure-diagram canvas::-webkit-scrollbar {
  width: 1px;
  background-color: #f5f5f5;
}

.structure-diagram canvas::-webkit-scrollbar-thumb {
  background-color: #777777;
}
</style>
